<template>
  <div class="v-visit">
    <Header></Header>
    <Navigation></Navigation>
    <div class="v-visit__content container">
      <div class="flex-row">
        <div class="flex-col">
          <Term />
        </div>
        <div class="flex-col flex-col--4 ml--3">
          <Summary></Summary>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>

import Footer from '@/components/footer.vue'
import Header from '@/components/header.vue'
import Navigation from "@/components/navigation";

import Summary from "@/components/services/summary";
// import Dates from "@/components/visit/dates";

import Term from "@/components/services/term";




export default {
  name: 'visit',
  components: {
    Footer,
    Header,
    Navigation,
    Summary,
    Term
    // Dates,
  }
}
</script>
<style lang="scss">
.v-visit {
  &__content {
    min-height: 90vh;
  }
}
</style>